<template>
  <v-main>
    <MainMenu />
    <div class="responsive-public-template-content">
      <div class="row" v-if="displayForm">
        <div class="col-12 text-center">
          <h3>Réinitialisation de votre mot de passe</h3>
        </div>
        <div class="col-12 offset-md-3 col-md-6">
          <ResetPasswordForm />
        </div>
      </div>
    </div>
    <Footer />
  </v-main>
</template>

<script>
import MainMenu from "@/components/common/MainMenu";
import Footer from "@/components/common/Footer";
import ResetPasswordForm from "@/components/ResetPassword/ResetPasswordForm";
import HttpClient from "@/services/HttpClient/HttpClient";
export default {
  name: "ResetPasswordPage",
  data() {
    return {
      displayForm: false,
    };
  },
  components: { Footer, MainMenu, ResetPasswordForm },
  mounted() {
    if (this.$route.params.token !== undefined) {
      const httpClient = new HttpClient();
      httpClient
        .checkResetTokenIsValid(this.$route.params.token)
        .then(() => {
          this.displayForm = true;
        })
        .catch((error) => {
          console.error(error);
          if (error.response.status === 404) {
            this.$router.push({ name: "not_found" });
          } else {
            alert("Une erreur s'est produite");
          }
        });
    }
  },
};
</script>

<style scoped></style>
